import { render, staticRenderFns } from "./FileStatusBelumKembali.vue?vue&type=template&id=4f2be4cb&scoped=true"
import script from "./FileStatusBelumKembali.vue?vue&type=script&lang=js"
export * from "./FileStatusBelumKembali.vue?vue&type=script&lang=js"
import style0 from "./FileStatusBelumKembali.vue?vue&type=style&index=0&id=4f2be4cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2be4cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2be4cb')) {
      api.createRecord('4f2be4cb', component.options)
    } else {
      api.reload('4f2be4cb', component.options)
    }
    module.hot.accept("./FileStatusBelumKembali.vue?vue&type=template&id=4f2be4cb&scoped=true", function () {
      api.rerender('4f2be4cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/monitoring_pasien/FileStatusBelumKembali.vue"
export default component.exports